var exports = {
  "N": "orgLink__5yxaKn",
};

module.exports = exports;
